import toastNotify from './toastNotify';

type SizeInput = string | number | null | undefined;

export const parseSizeToBytes = (size: SizeInput): number | null => {
  if (size === null || size === undefined || size === '') {
    return null;
  }

  if (typeof size === 'number') {
    return Number.isFinite(size) ? size : null;
  }

  const regex = /^(\d+(?:\.\d+)?)\s*(B|KB|MB|GB|TB|PB)?$/i;
  const match = size.trim().match(regex);
  if (!match) {
    return null;
  }

  const value = parseFloat(match[1]);
  const unit = (match[2] ?? 'B').toUpperCase();

  const units: Record<string, number> = {
    B: 1,
    KB: 1024,
    MB: 1024 * 1024,
    GB: 1024 * 1024 * 1024,
    TB: 1024 * 1024 * 1024 * 1024,
    PB: 1024 * 1024 * 1024 * 1024 * 1024,
  };

  return value * units[unit];
};

const convertToBytes = (size: SizeInput): number | null => {
  const bytes = parseSizeToBytes(size);

  if (bytes === null && size) {
    toastNotify('Format not matched', 'error');
  }

  return bytes;
};

export default convertToBytes;
